/**
 * ? @description : Add Ungrouped Teacher Component
 */

// Dependencies
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Axios Component
import Axios from "../../../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../../../redux/features/appSlice";

// CSS Component
import "../../../../../../../css/CreateGroup.css";
import { ShowListInTooltip } from "../../../../../../Reusable/ShowListInTooltip";
import dayjs from "dayjs";
import { ShowFullText } from "../../../../../../Reusable/ShowMoreText";
import { Typography } from "@mui/material";
import axios from "axios";

const ShowFullTextRenderer = (props) => {
  // console.log(props.value);
  const  value  = props.value;
  
  return (
    <ShowFullText title={value}>
      <Typography variant='p' sx={{ cursor: "pointer" }}>
        {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      </Typography>
    </ShowFullText>
  );
};

export default function AddTeacherParticipantModal(props) {
  // * Redux Variables
  const dispatch = useDispatch(); 

  // * State Variables
  // const [selectedValue, setSelectedValue] = useState([]);
  const [filterData, setFilterData] = useState([]);

  // ? API Call : Get Method : Get Ungrouped Teachers Data
  const onGridReady = async (params) => {
    const controller = axios.CancelToken.source();
    try {
      setFilterData(params.api);

      const teachers = await Axios("get", "teacher/get/batch/view/activeteacherslist", true, null, { cancelToken: controller.token });

      // const batches = await Axios("get", "teacher/countofbatches/teachers", true, null);

      // if(!Array.isArray(batches.data)){
      //   batches.data = [];
      // }
      // console.log(batches.data);
      if(teachers.status === 200 && Array.isArray(teachers.data)){
        // const overallList = await teachers.data.map((teachers) => {
        //   let index = batches.data.findIndex(item => item.teacher_id === teachers.teacher_id)
        //   return index !== -1 ? {...teachers, batch_count: batches.data[index].batch_count} : {...teachers, batch_count: 0}
          
        // })
  
        // console.log(overallList);
        params.api.applyTransaction({ add: teachers.data });
      }else{
        params.api.applyTransaction({ add: [] });
      }
    } catch (error) {
      if(!axios.isCancel(error)){       console.log(error);
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable to fetch data.",
            severity: "error",
          })
        );}
    }
    return () => {
      controller.cancel();
  }
  };



  // * Column Definitions for the Table
  const columnHeader = [
    {
      headerName: "Select",
      // field: "teacher_id",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      sortable: true,
      filter: true,
      maxWidth: 150
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Languages",
      field: "teacherlanguages",
      sortable: true,
      filter: true,
      cellRenderer:'showFullTextRenderer'
    },
    {
      headerName: "E-mail",
      field: "email",
      sortable: true,
      filter: true,
    },
    // {
    //   headerName: "Contact Number",
    //   field: "contactno",
    //   sortable: true,
    //   filter: true,
    // },
    {
      headerName: "Tentative start date",
      field: "tentative_start_date",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        return dayjs(params.value).format("DD-MM-YYYY")
      }
    },
    // {
    //   headerName: "Group count",
    //   field: "batch_count",
    //   sortable: true,
    //   filter: true,
    //   maxWidth: 150,
    //   cellRenderer: (params) => {
    //     let id = params.data.teacher_id
    //     return(
    //       params.value !== 0 ? <ShowListInTooltip value={params.value} getUrl={`teacher/batchesnames/teachers/${id}`} property="batch_name"></ShowListInTooltip> : "(0)"
    //     )
    //   }
    // },
  ];

  // * Row Selection Event : "Multiple"
  const rowSelectionType = "multiple";

  // * to show the full language in row 
  const components = {
    showFullTextRenderer: ShowFullTextRenderer, 
  };

  // * Store Selected Row Data in Props Variable
  const onSelectionChanged = (event) => {
    // setSelectedValue(event.api.getSelectedRows());
    props.selectedteacher(event.api.getSelectedRows());
  };
  // * Filter Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  return (
    <Modal
      {...props}
      size="xl"
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="modalHeader">Teachers List</h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Input Field */}
        <div className="my-2">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="Search"
            style={{
              width: "200px",
              padding: "10px",
              border: "1px solid #1D3FAA",
              borderRadius: "20px",
              outline: "none",
            }}
            onChange={onFilterTextChange}
          />
        </div>

        {/* Table */}
        <div
          className="ag-theme-alpine my-3"
          style={{ width: "85%", height: "540px", margin: "0 auto" }}
        >
          <AgGridReact
            onGridReady={onGridReady}
            columnDefs={columnHeader}
            rowSelection={rowSelectionType}
            onSelectionChanged={onSelectionChanged}
            rowMultiSelectWithClick={true}
            pagination={true}
            paginationPageSize={10}
            components={components}
            // paginationAutoPageSize={true}
          />
          {/* <ul>
            {selectedValue.map((value, index) => {
              return <li key={index}>{value.teacher_name}</li>;
            })}
          </ul> */}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="button"
          variant="light"
          className="batchCancel"
          onClick={props.onHide}
        >
          CLOSE
        </Button>

        <Button
          type="button"
          variant="primary"
          className="batchSave"
          onClick={() => props.onHide()}
        >
          SAVE
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
